export default "__VITE_ASSET__BmCpaXy7__"